import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobile-modal__bottom" }
const _hoisted_2 = { class: "mobile-modal__header" }
const _hoisted_3 = { class: "mobile-modal__header--title" }

import { PanelBar as KPanelBar, PanelBarSelectEventArguments } from '@progress/kendo-vue-layout';
import { Button as kButton } from '@progress/kendo-vue-buttons';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomMobileMenuModal',
  props: {
  menuItems: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
},
  emits: ['close'],
  setup(__props) {





function handleSelect(event: PanelBarSelectEventArguments) {
  if (event.target?.url && event.target?.url?.length > 2) {
    window.location.href = event.target?.url;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      _createVNode(_unref(kButton), {
        "fill-mode": 'solid',
        "icon-class": 'cwx-icon cwx-icon-before_close',
        size: 'small',
        "theme-color": 'tertiary',
        type: 'button',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    (__props.menuItems?.length > 0)
      ? (_openBlock(), _createBlock(_unref(KPanelBar), {
          key: 0,
          class: _normalizeClass('mobile-menu'),
          items: __props.menuItems,
          onSelect: handleSelect
        }, null, 8, ["items"]))
      : _createCommentVNode("", true)
  ]))
}
}

})